<template>
  <v-dialog max-width="500" @click:outside="closeModal">
    <v-card class="rounded-lg h-auto bg-white font-inter">
      <div class="w-full relative">
        <img
          src="../../../assets/icon/background-pattern.png"
          alt="background-pattern"
          loading="lazy"
          class="w-52 h-auto absolute top-0 -left-[2px]"
        />
        <div class="flex justify-between pb-3 pt-[10px] pl-2 pr-4">
          <div class="">
            <div class="p-2 bg-red-200 rounded-full w-fit">
              <div class="p-3 bg-red-600 rounded-full">
                <img
                  src="../../../assets/icon/warning.svg"
                  alt="icon"
                  loading="lazy"
                />
              </div>
            </div>
            <div class="ml-3">
              <h3 class="mt-3 text-slate-900 font-semibold text-lg relative">
                Peringatan!
              </h3>
              <h5 class="font-normal text-sm">
                Terdapat form input yang tidak sesuai ketentuan.
              </h5>
            </div>
          </div>
          <i
            @click="closeModal"
            class="mdi mdi-close text-2xl cursor-pointer text-gray-500"
            id="modal_icon_click_close"
          ></i>
        </div>
      </div>
      <div class="px-5">
        <ol class="font-normal text-sm list-decimal pl-4">
          <li v-for="item in data" :key="item">{{ item }}</li>
        </ol>
      </div>
      <div class="w-full gap-3 mt-3 px-5 pb-5">
        <v-btn
          @click="closeModal"
          id="modal_btn_click_close"
          variant="outlined"
          class="w-full border-gray-500 bg-white"
        >
          <span class="capitalize text-gray-600 text-sm">Tutup</span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalValidation",
  props: {
    data: Array,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>
